export enum CompleteCardStage {
  CompleteCardSetupStage = 'CompleteCardSetupStage',
  CompleteCardDeliveryStage = 'CompleteCardDeliveryStage',
  CompleteCardInviteStage = 'CompleteCardInviteStage',
  CompleteCardSetupReplacementStage = 'CompleteCardSetupReplacementStage',
  CompleteCardReplacementDeliveryStage = 'CompleteCardReplacementDeliveryStage',
}

export type CompleteCardStateConfigType = {
  hasOpenTransition?: boolean
  pathname?: string
}

export interface CompleteCardSetupState {
  stage: CompleteCardStage.CompleteCardSetupStage
  cardId: string
}

export interface CompleteCardDeliveryState {
  stage: CompleteCardStage.CompleteCardDeliveryStage
  cardholderName: string
}

export interface CompleteCardReplacementDeliveryState {
  stage: CompleteCardStage.CompleteCardReplacementDeliveryStage
}

export interface CompleteCardInviteState {
  stage: CompleteCardStage.CompleteCardInviteStage
  cardholderFirstName: string
}

export interface CompleteCardReplacementSetupState {
  stage: CompleteCardStage.CompleteCardSetupReplacementStage
  cardholderFirstName: string
  cardId: string
}

export type CompleteCardState =
  | CompleteCardSetupState
  | CompleteCardDeliveryState
  | CompleteCardInviteState
  | CompleteCardReplacementSetupState
  | CompleteCardReplacementDeliveryState
